import { combineReducers } from '@reduxjs/toolkit';
import { map3dReducers } from 'map-3d/map-3d-reducers';
import { uploadWidgetReducer } from 'shared/upload-widget-slices';
import { dashboardReducers } from 'src/dashboard/dashboard-reducers';
import { projectReducers } from 'src/projects/project-reducers';
import { swipeMap3DReducer } from 'src/swipe-map-3d';
import { swipeMapReducers } from 'src/swipe-map/swipe-map-reducers';

const rootReducer = combineReducers({
  map3d: map3dReducers,
  dashboard: dashboardReducers,
  project: projectReducers,
  swipeMap: swipeMapReducers,
  swipeMap3D: swipeMap3DReducer,
  uploadWidget: uploadWidgetReducer,
});

export default rootReducer;
